import { cva } from 'class-variance-authority'

export const inputHelperVariants = cva(
  'text-2xs font-sans first-letter:uppercase w-full',
  {
    variants: {
      variant: {
        default: 'text-gray-medium',
        danger: 'text-red',
        success: 'text-green',
        warning: 'text-orange',
      },
      padding: {
        base: 'px-4',
      },
    },
    defaultVariants: {
      variant: 'default',
      padding: 'base',
    },
  }
)
